<script setup lang="ts">
import { computed } from 'vue'
import { useI18n, useRoute } from '@fusapp-work/shell'
import { useCurrentSession } from '../../composables/useCurrentSession'
import { useCurrentPersonnel } from '../../features/organization/personnel/useCurrentPersonnel'
import ConsoleAccountIcon from './ConsoleAccountIcon.vue'
const emit = defineEmits<{ navigate: [] }>()
const { t } = useI18n(); const route = useRoute(); const { state } = useCurrentSession()
const current = useCurrentPersonnel()
const admin = computed(() => state.status === 'authenticated' && state.session?.roles.includes('System_Admin'))
const available = computed(() => admin.value && current.isSuccess.value && Boolean(current.data.value?.personnelId))
const links = [{ tab: 'sessions', label: 'mySessions', sub: 'mySessionsDescription', icon: 'key' }, { tab: 'access', label: 'myPermissions', sub: 'myPermissionsDescription', icon: 'shield' }] as const
function target(tab: string) { return { name: 'organization-users', query: { ...(typeof route.query.orgId === 'string' ? { orgId: route.query.orgId } : {}), personnelId: current.data.value?.personnelId, tab } } }
</script>
<template>
  <div class="console-account-links">
    <a
      class="console-profile-link"
      href="https://myaccount.microsoft.com"
      target="_blank"
      rel="noopener noreferrer"
      @click="emit('navigate')"
    >
      <ConsoleAccountIcon name="users" /><span><strong>{{ t('consoleShell.myProfile') }}</strong><small>{{ t('consoleShell.profileDescription') }}</small></span>
    </a>
    <template
      v-for="link in links"
      :key="link.tab"
    >
      <router-link
        v-if="available"
        class="console-profile-link"
        :data-account-tab="link.tab"
        :to="target(link.tab)"
        @click="emit('navigate')"
      >
        <ConsoleAccountIcon :name="link.icon" /><span><strong>{{ t(`consoleShell.${link.label}`) }}</strong><small>{{ t(`consoleShell.${link.sub}`) }}</small></span>
      </router-link>
      <button
        v-else
        class="console-profile-link"
        :data-account-tab="link.tab"
        disabled
        aria-disabled="true"
        aria-describedby="console-profile-status"
      >
        <ConsoleAccountIcon :name="link.icon" /><span><strong>{{ t(`consoleShell.${link.label}`) }}</strong><small>{{ t(`consoleShell.${link.sub}`) }}</small></span>
      </button>
    </template>
    <p
      v-if="!available"
      id="console-profile-status"
      class="console-account-status"
      role="status"
    >
      {{ t(!admin ? 'consoleShell.profilePermission' : current.isPending.value ? 'organization.common.loading' : 'consoleShell.profileUnavailable') }}<button
        v-if="admin && current.isError.value"
        type="button"
        @click="current.refetch()"
      >
        {{ t('organization.common.retry') }}
      </button>
    </p>
  </div>
</template>
